// ... existing code ...
import { defineStore } from 'pinia'
import pinia from '@/stores'
import { ref } from 'vue'
import { STORAGE_TOKEN_KEY, STORAGE_USER_INFO_KEY } from '@/stores/mutation-type'
import { loginApi, registerApi, logout } from '@/api/login' // , userInfoApi
import { maskString } from '@/utils/maskString'
import { initWebSocket, closeWebSocket } from '@/utils/websocketService'
import { useWebSocketStore } from '@/stores/websocketStore'
import { useEventBus } from '@vueuse/core'
import router from '@/router'

// const websocketUrl = 'ws://47.83.14.127:8282' // 替换为实际的 WebSocket URL
const imageModules = import.meta.glob('@/assets/theme/avatar/*.png', { eager: true })
export const useUserStore = defineStore('user', () => {
  const accoutToken = ref(localStorage.getItem(STORAGE_TOKEN_KEY) || '')
  const userInfo = ref(JSON.parse(localStorage.getItem(STORAGE_USER_INFO_KEY)) || {})
  const messageUnread = ref(0)

  // 注册
  async function register(data) {
    const res = await registerApi(data)
    setUserInfoFn(res)
    return res
  }

  // 登录
  async function handleLogin(data) {
    // console.log('datazhanghu mima:', data)
    const res = await loginApi(data)
    // console.log('datazhanghu res:', res)
    setUserInfoFn(res)
    return res
  }

  // 设置用户信息
  async function setUserInfoFn(res) {
    if (res.code == 1 && res.data.token) {
      const { token, nickname, phone } = res.data
      accoutToken.value = token
      userInfo.value = {
        ...res.data,
        maskNickname: maskString(nickname),
        maskPhone: maskString(phone, { maskStart: 0, maskEnd: -3 }),
      }
      localStorage.setItem(STORAGE_TOKEN_KEY, token)
      localStorage.setItem(STORAGE_USER_INFO_KEY, JSON.stringify(userInfo.value))
      // 此处触发 初始化ws
      // console.log('此处触发 初始化ws')
      // initWebSocket(websocketUrl, (message) => {
      //   // 监听消息
      //   console.log('监听消息...:', message)
      // })
      // const hadToken = localStorage.getItem(STORAGE_TOKEN_KEY)
      // 只有登录了才初始化 WebSocket
      // if (hadToken) {
      //   console.log('只有登录了才初始化 WebSocket:', hadToken)
      //   initWebSocket(websocketUrl, async (message) => {
      //     console.log('只有登录了才初始化 WebSocket2222')
      //     console.log('Received WebSocket message:', message)
      //     // 可以在这里触发全局事件或更新状态
      //     if (message.type == 'connected' && message?.client_id) {
      //       // clientId 绑定用户ID
      //       const clientId = message.client_id
      //       localStorage.setItem('clientId', clientId)

      //       // 直接调用useWebSocketStore的bindUser方法
      //       const websocketStore = useWebSocketStore(pinia)
      //       try {
      //         await websocketStore.bindUser(clientId)
      //         console.log('main ts clientId bound to WebSocket connection:', clientId)
      //       } catch (error) {
      //         console.error('main ts  Failed to bind clientId to WebSocket:', error)
      //       }
      //     }

      //     if (message.type == 'mailReceive' && message?.body) {
      //       // 如果用户在邮件页面，则广播通知邮件页面插入数据，如果不在邮件页面需要全局弹窗提示吗
      //       const currentRoute = router.currentRoute.value.name
      //       if (currentRoute === 'Mail') {
      //         // 发送事件通知邮件页面
      //         const mailEventBus = useEventBus('mail-received')
      //         mailEventBus.emit(message.body)
      //       } else {
      //         // 显示全局通知
      //         const notificationEventBus = useEventBus('global-notification')
      //         notificationEventBus.emit({
      //           type: 'mail',
      //           message: message.body.title || 'Você recebeu um novo e-mail',
      //         })
      //       }
      //     }

      //     if (message.type == 'unbind' && message?.body) {
      //       console.log('unbind...')
      //       localStorage.removeItem(STORAGE_TOKEN_KEY)
      //       localStorage.removeItem(STORAGE_USER_INFO_KEY)
      //       localStorage.setItem('active', '0')
      //       closeWebSocket()
      //       nextTick(() => {
      //         window.location.href = '/'
      //         // window.location.reload()
      //       })
      //     }
      //   })
      // }
    }
  }
  // 更新用户信息
  function updateUserInfo(data) {
    const { nickname, phone } = data
    userInfo.value = {
      ...userInfo.value,
      maskNickname: maskString(nickname),
      maskPhone: maskString(phone, { maskStart: 0, maskEnd: -3 }),
      ...data,
    }
    localStorage.setItem(STORAGE_USER_INFO_KEY, JSON.stringify(userInfo.value))
  }
  // 登出 idModal = { id ： xxx} idModal
  async function handleLogout() {
    if (accoutToken.value) {
      await logout()
      const newlocalConfig = JSON.parse(localStorage.getItem('localConfig'))
      const newinitConfig = JSON.parse(localStorage.getItem('initConfig'))
      const deviceId = localStorage.getItem('deviceId')
      const id = localStorage.getItem('id') || ''
      const channel_id = localStorage.getItem('channel_id') || ''
      const business_id = localStorage.getItem('business_id') || ''
      localStorage.clear()
      accoutToken.value = ''
      userInfo.value = {}
      localStorage.setItem('active', 0)
      localStorage.setItem('localConfig', JSON.stringify(newlocalConfig))
      localStorage.setItem('initConfig', JSON.stringify(newinitConfig))
      localStorage.setItem('id', id)
      localStorage.setItem('channel_id', channel_id)
      localStorage.setItem('business_id', business_id)
      if (deviceId) {
        localStorage.setItem('deviceId', deviceId)
      }
      closeWebSocket()
      const openLoginBus = useEventBus('open-login-popup')
      openLoginBus.emit()
      router.push({ name: 'Home', query: { refresh: Date.now().toString() } })
    } else {
      // router.push({ name: 'Home' })
      router.push({ name: 'Home', query: { refresh: Date.now().toString() } })
    }
  }

  /**
   * 昵称模块
   */
  // 更新昵称的方法
  function updateNickname(nickname) {
    userInfo.value.nickname = nickname
    userInfo.value.maskNickname = maskString(nickname)
    localStorage.setItem(STORAGE_USER_INFO_KEY, JSON.stringify(userInfo.value))
  }

  /**
   * 手机号模块
   */
  // 更新手机号的方法
  function updatePhone(phone) {
    userInfo.value.phone = phone
    userInfo.value.maskPhone = maskString(phone, { maskStart: 0, maskEnd: -3 })
    localStorage.setItem(STORAGE_USER_INFO_KEY, JSON.stringify(userInfo.value))
  }
  /**
   * 头像模块
   */
  function getAvatarImage(idx) {
    const imagePath = `/src/assets/theme/avatar/avatar${idx}.png`
    return imageModules[imagePath]?.default
  }

  /**
   * 获取本地所有头像并按性别分割
   */
  function getLocalAllAvatar() {
    const maleAvatars = [] // 男头：avatar0 - avatar23
    const femaleAvatars = [] // 女头：avatar24 - avatar47

    Object.keys(imageModules).forEach((key) => {
      const module = imageModules[key]
      // 提取头像编号
      const num = parseInt(key.split('/').pop().split('avatar').pop().split('.')[0])

      const avatarObj = {
        id: module?.default,
        url: module?.default,
        index: num,
        gender: num < 24 ? 'male' : 'female',
      }

      // 根据编号分割到不同数组
      if (num < 24) {
        maleAvatars.push(avatarObj)
      } else {
        femaleAvatars.push(avatarObj)
      }
    })
    // 对男头数组和女头数组分别按照 index 进行升序排序
    maleAvatars.sort((a, b) => a.index - b.index)
    femaleAvatars.sort((a, b) => a.index - b.index)
    return {
      male: maleAvatars, // 男头数组
      female: femaleAvatars, // 女头数组
      all: [...maleAvatars, ...femaleAvatars], // 所有头像（保持兼容性）
    }
  }

  /**
   * 获取男性头像列表 (avatar0 - avatar23)
   */
  function getMaleAvatars() {
    const avatars = getLocalAllAvatar()
    return avatars.male
  }

  /**
   * 获取女性头像列表 (avatar24 - avatar47)
   */
  function getFemaleAvatars() {
    const avatars = getLocalAllAvatar()
    return avatars.female
  }

  /**
   * 根据性别获取头像列表
   * @param {string} gender - 'male' 或 'female'
   */
  function getAvatarsByGender(gender) {
    const avatars = getLocalAllAvatar()
    return gender === 'male' ? avatars.male : avatars.female
  }

  // 获取用户头像的方法
  // function getUserAvatar() {
  //   return localStorage.getItem(STORAGE_USER_INFO_KEY)?.avatar || 0
  // }

  // 更新用户头像的方法
  function updateUserAvatar(avatarUrl) {
    userInfo.value.avatar = avatarUrl
    localStorage.setItem(STORAGE_USER_INFO_KEY, JSON.stringify(userInfo.value))
  }

  // 更新未读消息数量
  async function updateMessageUnread(data) {
    messageUnread.value = data
  }

  // 获取用户信息 idModal = { id ： xxx}
  // async function fetchUserInfo(idModal) {
  //   const res = await userInfoApi(idModal)
  //   if (res) {
  //     const { data } = res
  //     userInfo.value = data
  //     localStorage.setItem(STORAGE_USER_INFO_KEY, JSON.stringify({ ...data }))
  //     return true
  //   }
  // }

  return {
    token: accoutToken,
    userInfo,
    messageUnread,
    handleLogin,
    handleLogout,
    // fetchUserInfo,
    register,
    updateUserAvatar,
    getAvatarImage,
    getLocalAllAvatar,
    getMaleAvatars,
    getFemaleAvatars,
    getAvatarsByGender,
    updateNickname,
    updatePhone,
    updateMessageUnread,
    updateUserInfo,
  }
})
// ... existing code ...
